/** Shared spines P2 — pure trail → residents resolver. Resident names come
 *  from the camp markers' join-time stamps (the walk-up cursor resolver
 *  finds only ONE root; a shared trail has N). Pure module — no React, no
 *  api imports (CRA-jest import.meta discipline). Dismissals are roster
 *  state the messages can't see: the ack's dispatched[] is truth post-send;
 *  this list drives pre-send pill copy. */
export interface TrailResident {
  spineRootMessageId: string;
  personaId: string | null;
  name: string | null;
}

interface MinimalMsg {
  id: string;
  metadata?: Record<string, any>;
}

export function trailResidents(
  messages: MinimalMsg[], trailId: string | null,
): TrailResident[] {
  if (!trailId) return [];
  return messages
    .filter((m) => m.metadata?.is_spine_root === true
      && (m.metadata?.trail_id ?? null) === trailId)
    .map((m) => ({
      spineRootMessageId: m.id,
      personaId: m.metadata?.persona_id ?? null,
      name: m.metadata?.persona_display_name_at_join ?? null,
    }));
}

/** "Bravo" · "Bravo & Joiner" · "A, B & 2 more". Null when no displayable
 *  names (uuids are banned in operator copy). Accepts TrailResident[] or
 *  plain names — EVERY surface (cursor pill, morph copy) formats through
 *  here so the truncation threshold can't drift (triad rev 1.1). */
export function residentNamesCopy(
  residents: (TrailResident | string | null)[],
): string | null {
  const names = residents
    .map((r) => (typeof r === 'string' ? r : r?.name))
    .filter(Boolean) as string[];
  if (names.length === 0) return null;
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} & ${names[1]}`;
  return `${names[0]}, ${names[1]} & ${names.length - 2} more`;
}
